import React from "react";
import "../MerchantModule/styles/MerchantScreen.css"; // Reusing the same styles
import SideBar from "../../Common/SideBar";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { OvalLoader } from "../../Common/Loaders";
import { useFetchAllCustomersQuery } from "../../../services/baseQuery";

export default function AllCustomerScreen() {
  const sidebar = useSelector((state) => state.sidebar);
  const {
    isLoading,
    isError,
    data: allCustomers,
    error,
  } = useFetchAllCustomersQuery();

  console.log(allCustomers, "<<< all acust");

  return (
    <div className="MainContainer">
      <SideBar />
      <div
        style={{ width: sidebar.expand ? "84vw" : "95vw" }}
        className="ScreenContainer"
      >
        {/* upper search bar start */}

        <div className="upperSearchBarContainer">
          <div className="upperBarSearchBar">
            <div className="pageHeadingInnerContainer">
              <div className="pageHeading">All Customers</div>
            </div>
          </div>

          <div
            className="upperBarSearchBox upperBarSearchBoxProfile"
            style={{ border: "none" }}
          >
            <img
              src={require("../../../assets/profile.png")}
              alt="profile-pic"
            />
          </div>
          <div className="upperBarSearchBox upperBarSearchBoxNotification">
            <img
              src={require("../../../assets/exit.png")}
              alt="notification-bell"
            />
          </div>
        </div>
        <div
          className="upperSearchBarContainer"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1.5vh",
          }}
        >
          <input placeholder="Search..." className="upperBarSearchBarInput" />
          <div className="searchButton">Search</div>
        </div>
        <div className="verificationTableContainer">
          <div className="verificationTableRow">
            <div
              style={{ width: "10%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Sr. No.
            </div>
            <div
              style={{ width: "25%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Name
            </div>
            <div
              style={{ width: "25%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Phone Number
            </div>
            <div
              style={{ width: "25%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Email
            </div>
            <div
              style={{ width: "15%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              View Profile
            </div>
          </div>
          {isLoading ? (
            <OvalLoader visible={true} color="#3366CC" />
          ) : (
            allCustomers?.map((item, i) => (
              <div
                className="verificationTableRow"
                key={i}
                style={{
                  backgroundColor: i % 2 == 0 ? "#6b5acd0e" : "#6b5acd1d",
                }}
              >
                <div
                  style={{ width: "10%", height: "100%" }}
                  className="eachColumn eachTableBody"
                >
                  {i + 1}
                </div>
                <div
                  style={{
                    width: "25%",
                    height: "100%",
                    textDecoration: "underline",
                    whiteSpace: "nowrap",
                  }}
                  className="eachColumn eachTableBody"
                >
                  {item.displayName?.slice(0, 19) || "-"}
                </div>
                <div
                  style={{ width: "25%", height: "100%" }}
                  className="eachColumn eachTableBody"
                >
                  {item.phoneNumber || "-"}
                </div>
                <div
                  style={{ width: "25%", height: "100%" }}
                  className="eachColumn eachTableBody"
                >
                  {item.email || "-"}
                </div>
                <NavLink
                  to={`/allCustomers/${item.id}`}
                  style={{
                    width: "15%",
                    height: "100%",
                    textDecoration: "underline",
                    color: "#3366CC",
                  }}
                  className="eachColumn eachTableBody"
                >
                  View Profile
                </NavLink>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
